import { Currency, DeliveryStatus, Locale } from '@synergy/models';

import { WishListItem, WishListItemStatus } from '../wish-list';
import { WishListItemDto } from '../dto/wish-list-dto';
import { mapWishListArticle } from './wish-list-article-mapper';

export const mapWishListItem = (item: WishListItemDto, locales: Locale[], currency: Currency): WishListItem | null => {
    const article = mapWishListArticle(locales, currency, item.product);
    if (article === null) {
        return null;
    }

    let status = WishListItemStatus.Available;
    if (item.product.deliveryStatus === DeliveryStatus.OnRequest) {
        status = WishListItemStatus.PriceByRequest;
    } else if (!item.isAvailableForPurchase) {
        status = WishListItemStatus.Removed;
    }

    return {
        id: item.id,
        netPrice: item.netPrice,
        previewImage: item.previewImage,
        quantity: item.quantity,
        product: article,
        status,
    };
};
